import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import MessageBubble from "./MessageBubble";

const ChatConversation = ({ messages = [], showWhatsAppBanner = true }) => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const bottomRef = useRef(null);

  // Automatically scroll to bottom when messages list changes
  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#F8FAFC",
        position: "relative"
      }}
    >
      {/* WhatsApp sync info banner — external chats only */}
      {showWhatsAppBanner && isBannerVisible && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#FFFBEB",
            borderBottom: "1px solid #FEF3C7",
            px: 3,
            py: 1,
            zIndex: 1
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            <InfoIcon sx={{ color: "#D97706", fontSize: "18px" }} />
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "500",
                color: "#B45309",
                fontFamily: "Montserrat"
              }}
            >
              Messages are synced from WhatsApp.{" "}
              <span
                style={{
                  textDecoration: "underline",
                  fontWeight: "600",
                  cursor: "pointer"
                }}
              >
                Learn more
              </span>
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => setIsBannerVisible(false)}
            sx={{
              color: "#B45309",
              p: 0.5,
              "&:hover": { backgroundColor: "#FEF3C7" }
            }}
          >
            <CloseIcon sx={{ fontSize: "14px" }} />
          </IconButton>
        </Box>
      )}

      {/* Messages Scroll Zone */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          px: 3,
          pt: 2,
          pb: 4,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {/* Date Separator */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            my: 2
          }}
        >
          <Box
            sx={{
              backgroundColor: "#E2E8F0",
              borderRadius: "12px",
              px: 2,
              py: 0.5
            }}
          >
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "600",
                color: "#64748B",
                fontFamily: "Montserrat"
              }}
            >
              Today
            </Typography>
          </Box>
        </Box>

        {/* Message List */}
        {messages.map((message) => (
          <MessageBubble key={message.id} message={message} />
        ))}

        {/* Spacer so last message (esp. images) isn't clipped above the input */}
        <Box ref={bottomRef} sx={{ height: 24, flexShrink: 0 }} />
      </Box>
    </Box>
  );
};

export default ChatConversation;
